import React, { useCallback, useState, useEffect } from 'react';
import pt_BR from 'date-fns/locale/pt-BR';
import { useTheme } from 'styled-components';
import { useHistory } from 'react-router-dom';

import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { format } from 'date-fns';
import Actions from '../../components/Actions';

import BRLMoneyFormat from '../../utils/BRLMoneyFormat';

import api from '../../services/api';

import {
  Container,
  Wrapper,
  MenuTable,
  Filter,
  Table,
  StatusField,
  Pagination,
} from './styles';
import { useToast } from '../../hooks/toast';
import Button from '../../newComponents/Button';
import { useAuth } from '../../hooks/auth';
import PromotionsService, { IPromotion } from '../../services/PromotionsService';

const FreeDelivery: React.FC = () => {
  const theme = useTheme();
  const history = useHistory();
  const { addToast } = useToast();
  const { rotinas, findRotinas, user } = useAuth();

  const [filter, setFilter] = useState('all');
  const [promotions, setPromotions] = useState<IPromotion[]>([]);

  const hasPermission = useCallback(
    (): boolean => findRotinas('promocoes')?.listar || false,
    [findRotinas],
  );

  useEffect(() => {
    if (rotinas && !hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      history.push('/monitor_pedidos');
    }
  }, [addToast, hasPermission, history, rotinas]);

  const handleGoToPage = useCallback(
    (path: string, params?: Record<string, unknown>) => {
      history.push(path, params);
    },
    [history],
  );

  const handleStatusColors = useCallback(
    (status: boolean) => {
      if (status) {
        return theme.colors.green;
      }

      return theme.colors.red;
    },
    [theme],
  );

  function handleDeleteFreeDelivery(id: number) {
    PromotionsService.deletePromotion(id, user.empresa_id).then((res) => {
      setPromotions((prev) => prev.filter((promotion) => promotion.id !== id));

      addToast({
        type: 'success',
        title: 'Deletado com sucesso',
      });
    }).catch((error) => {
      addToast({
        type: 'error',
        title: 'Ocorreu um erro',
        description: (error as any).response.data.message || 'Tente novamente',
      });
    })
  };

  useEffect(() => {
    PromotionsService.listPromotions(user.empresa_id, filter, 1).then((res) => setPromotions(res))
    .catch((error) =>  console.log(error));
  }, [filter]);

  return (
    <Container>
      <Wrapper>
        <header>
          <div>
            <h1>Frete grátis</h1>
            <h3>
              As promoções são aplicadas automaticamente nas compras que atendem as condições delas.
            </h3>
          </div>
          <Button
            onClick={() => handleGoToPage('/frete-gratis/criar')}
            disabled={!hasPermission()}
          >
            <span>Adicionar promoção</span>
          </Button>
        </header>
        <MenuTable>
          <ul>
            <li>
              <Filter
                isActive={filter === 'all'}
                onClick={() => setFilter('all')}
              >
                Todos
              </Filter>
            </li>
            <li>
              <Filter
                isActive={filter === 'active'}
                onClick={() => setFilter('active')}
              >
                Ativos
              </Filter>
            </li>
            <li>
              <Filter
                isActive={filter === 'inactive'}
                onClick={() => setFilter('inactive')}
              >
                Inativos
              </Filter>
            </li>
          </ul>
        </MenuTable>
        <Table>
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Desconto</th>
              <th>Inicia em</th>
              <th>Válido até</th>
              <th>Status</th>
              {hasPermission() && <th>Ações</th>}
            </tr>
          </thead>
          <tbody>
            {promotions.map((promotion: IPromotion) => (
              <tr key={promotion.id}>
                <td>{promotion.description}</td>
                <td>
                  {
                    promotion.typeValue === 1 || promotion.typeValue === 3
                    ? Number(promotion.value).toLocaleString(
                        'pt-BR',
                        BRLMoneyFormat,
                      )
                    : `${promotion.value}%`
                  }
                </td>
                <td>
                  {promotion.startDate
                    ? format(new Date(promotion.startDate), "dd'/'MM'/'yyyy", {
                        locale: pt_BR,
                      })
                    : '-'}
                </td>
                <td>
                  {promotion.endDate
                    ? format(new Date(promotion.endDate), "dd'/'MM'/'yyyy", {
                        locale: pt_BR,
                      })
                    : '-'}
                </td>
                <td>
                  <StatusField color={handleStatusColors(promotion.active)}>
                    <span>{promotion.active ? 'ATIVO' : 'INATIVO'}</span>
                  </StatusField>
                </td>
                {hasPermission() && (
                  <td>
                    <Actions>
                      <button
                        type="button"
                        onClick={() =>
                          history.push(`/frete-gratis/editar/${promotion.id}`)
                        }
                        disabled={!hasPermission()}
                      >
                        Editar
                      </button>
                      <button
                        type="button"
                        className="danger"
                        onClick={() => handleDeleteFreeDelivery(promotion.id)}
                        disabled={!hasPermission()}
                      >
                        Excluir
                      </button>
                    </Actions>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination>
          <p>
            Mostrando <strong>{promotions.length}</strong> registros . Total:{' '}
            <strong>{promotions.length}</strong> registros
          </p>
          <div>
            <p>
              Limite por página: <strong>100 registros</strong>
            </p>
            <button
              type="button"
              disabled
              onClick={() => {
                // do nothing.
              }}
            >
              <MdChevronLeft />
            </button>
            <span>1</span>
            <button
              type="button"
              disabled
              onClick={() => {
                // do nothing.
              }}
            >
              <MdChevronRight />
            </button>
          </div>
        </Pagination>
      </Wrapper>
    </Container>
  );
};

export default FreeDelivery;
